export default "https://0f174046-a3c4-46d7-88af-9cfef9e6bcb2.selcdn.net/webpack/production/4711435765df53f40f2119812fdb8307.png";